(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sn39-moon-transition"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.Sn39MoonTransition) return;
    const overlay = document.querySelector('[data-sn39-moon-transition]');
    const moon = overlay?.querySelector('.sn39-moon-transition__moon');
    if (!overlay || !moon || !overlay.animate) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let animations = [];
    let lastPlay = -Infinity;
    const stop = () => {
      animations.forEach(animation => {
        animation.onfinish = null;
        animation.cancel();
      });
      animations = [];
      overlay.hidden = true;
    };
    const play = (duration = 960) => {
      if (reduced.matches || document.visibilityState !== 'visible' || performance.now() - lastPlay < 250) return;
      stop();
      lastPlay = performance.now();
      overlay.hidden = false;
      const veil = overlay.animate([
        { opacity: 0, offset: 0 },
        { opacity: 1, offset: .1 },
        { opacity: 1, offset: .7 },
        { opacity: 0, offset: 1 }
      ], { duration, easing: 'linear', fill: 'both' });
      const rotation = moon.animate([
        { transform: 'rotate(0deg)' },
        { transform: 'rotate(360deg)' }
      ], { duration: duration * .88, easing: 'cubic-bezier(.4,0,.2,1)' });
      animations = [veil, rotation];
      veil.onfinish = stop;
    };
    window.Sn39MoonTransition = { stop };
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') stop();
      else play(800);
    });
    window.addEventListener('pageshow', event => { if (event.persisted) play(); });
    window.addEventListener('pagehide', stop);
    document.addEventListener('pointerdown', stop, { passive: true });
    document.addEventListener('keydown', stop);
    reduced.addEventListener('change', stop);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => play(), { once: true });
    else play();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn40-header-logo"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.Sn40HeaderMoon) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const running = new Map();
    let lastPlay = -Infinity;
    const stop = () => {
      running.forEach(animation => {
        animation.onfinish = null;
        animation.cancel();
      });
      running.clear();
    };
    const play = (scope = document) => {
      if (reduced.matches || document.visibilityState !== 'visible' || performance.now() - lastPlay < 250) return;
      stop();
      lastPlay = performance.now();
      scope.querySelectorAll('.sn40-header-logo__moon').forEach(moon => {
        if (!moon.animate || !moon.getBoundingClientRect().width) return;
        const animation = moon.animate([
          { transform: 'rotate(0deg)' },
          { transform: 'rotate(360deg)' }
        ], { duration: 1000, easing: 'cubic-bezier(.4,0,.2,1)' });
        running.set(moon, animation);
        animation.onfinish = () => running.delete(moon);
      });
    };
    window.Sn40HeaderMoon = { stop };
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') stop();
      else play();
    });
    window.addEventListener('pageshow', event => { if (event.persisted) play(); });
    window.addEventListener('pagehide', stop);
    document.addEventListener('shopify:section:load', event => play(event.target));
    document.addEventListener('shopify:section:unload', stop);
    reduced.addEventListener('change', stop);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => play(), { once: true });
    else play();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv9-french-locale"] && !Shopify.designMode) return;
  try {
    (() => {
  const container = document.querySelector('[data-sv9-french-locale]');
  const form = container && container.querySelector('form');
  if (!form) return;
  const returnInput = form.querySelector('input[name="return_to"]');
  if (!returnInput) return;
  const current = new URL(window.location.href);
  const normalizeRoot = (root) => {
    const parsed = new URL(root || '/', current.origin);
    if (parsed.origin !== current.origin) return null;
    return parsed.pathname.replace(/\/$/, '');
  };
  const from = normalizeRoot(container.dataset.currentRoot);
  const to = normalizeRoot(container.dataset.frenchRoot);
  if (from === null || to === null) return;
  let suffix = current.pathname;
  if (from) {
    if (suffix !== from && !suffix.startsWith(from + '/')) return;
    suffix = suffix.slice(from.length);
  }
  const countryInput = form.querySelector('input[name="country_code"]');
  const attemptKey = 'somnila-v9-french:' + current.host + ':' + (countryInput ? countryInput.value : '');
  try {
    if (sessionStorage.getItem(attemptKey)) return;
    sessionStorage.setItem(attemptKey, '1');
  } catch (_) {
    return;
  }
  returnInput.value = to + (suffix || '/') + current.search + current.hash;
  form.requestSubmit();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv9-product-interactions"] && !Shopify.designMode) return;
  try {
    (function(){
  function boot(){
    document.querySelectorAll('.sv9-pdp').forEach(function(root){
      if(root.dataset.sv9Ready)return;
      root.dataset.sv9Ready='true';
      var opener=root.querySelector('[data-sv9-media-open]'),dialog=root.querySelector('[data-sv9-dialog]'),main=root.querySelector('[data-sv7-main]');
      if(!opener||!dialog||!main)return;
      var image=dialog.querySelector('img'),caption=dialog.querySelector('[data-sv9-lightbox-caption]');
      opener.addEventListener('click',function(){image.src=main.currentSrc||main.src;image.alt=main.alt;caption.textContent=main.alt;dialog.showModal();});
      dialog.querySelector('[data-sv9-close]').addEventListener('click',function(){dialog.close();});
      dialog.addEventListener('click',function(event){if(event.target===dialog){var r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',function(){opener.focus();});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
  } catch(e) { console.error(e); }
})();

})();
